﻿const en = {
  nav: {
    home: "Home",
    map: "Map",
    tracker: "Tracker",
    resources: "Resources",
    fish: "Fish",
    insects: "Insects",
    birds: "Birds",
    foraging: "Foraging",
    crops: "Crops",
    flowers: "Flowers",
    animals: "Animals",
    recipes: "Recipes",
    locations: "Locations",
    npcs: "NPCs",
    shops: "Shops",
    guides: "Guides",
    news: "News",
    achievements: "Achievements",
    weather: "Weather",
    events: "Events",
    pets: "Pets",
    dailyChecklist: "Daily Checklist",
    codes: "Gift Codes",
    winterTracker: "Winter Tracker",
    support: "Support",
    about: "About",
    furniture: "Furniture",
    wardrobe: "Wardrobe",
    buildings: "Building",
    resourcesCollection: "Collection",
    resourcesDecorate: "Decorate",
    resourcesExplore: "Explore",
    resourcesLearn: "Learn",
    menu: "Menu",
  },
  search: {
    placeholder: "Search everything…",
    categoryItems: "Collection",
    categoryNpcs: "NPCs",
    categoryLocations: "Locations",
    categoryGuides: "Guides",
    categoryNews: "News",
    categoryAchievements: "Achievements",
    noResults: "No results found",
    noResultsHint: "Try a different search term",
    navigate: "navigate",
    select: "select",
    close: "close",
  },
  language: {
    title: "Language",
    subtitle: "Choose your preferred language",
  },
  footer: {
    description: "A player-made Heartopia field guide for routes, recipes, locations and collection work.",
    quickLinks: "Quick Links",
    collection: "Collection",
    copyright: "Heartopia Hub",
    disclaimer: "Not affiliated with the developers of Heartopia.",
  },
  home: {
    badge: "Unofficial Heartopia companion",
    titleStop: "Stop",
    titleWandering: "wandering.",
    titleStart: "Start planning.",
    description:
      "Heartopia.guide puts the island map, recipes, creatures, NPCs and collection progress into one calm, fast workspace.",
    openAtlas: "Open atlas",
    tracker: "Tracker",
    statCatalogued: "Catalogued items",
    statLayers: "Map layers",
    statFree: "Always free",
    islandAtlas: "Island atlas",
    mapLayerNpcs: "NPCs",
    mapLayerShops: "Shops",
    mapLayerAnimals: "Animals",
    mapHeading: "Heartopia island",
    mapNearby: "nearby",
    openMap: "Open map",
    meetLocals: "Meet the locals",
    hintNpcs: "Chat-ready NPCs mapped into one quick glance.",
    hintShops: "Every shop stocked and ready to browse.",
    hintAnimals: "Wild animals roaming their usual spots.",
    explore: "Explore",
    recipesPill: "Recipes",
    recipesTitle: "Cook smarter",
    recipesDescription: "Browse dishes, ingredient chains and collection progress without opening ten tabs.",
    viewRecipes: "View recipes",
    ingr: "ingr.",
    profit: "profit",
    animalsPill: "Wild animals",
    animalsTitle: "Meet them all",
    animalsDescription: "Favorite foods, weather windows and map hints for every wild animal.",
    viewAnimals: "View animals",
    guidesPill: "Guides",
    guidesTitle: "Pick a focus",
    guidesDescription: "Three ways in — jump straight to the guide that matches what you're chasing this session.",
    allGuides: "All guides",
    exploreGuide: "Explore guide",
  },
  guides: {
    pillLabel: "Field Guides",
    titleLearn: "Learn",
    titleAccent: "Every System",
    searchPlaceholder: "Search guides…",
    categoryAll: "All",
    categoryBeginner: "Beginner",
    categoryCrafting: "Crafting",
    categoryCooking: "Cooking",
    categoryFishing: "Fishing",
    categoryExploration: "Exploration",
    difficultyEasy: "Easy",
    difficultyMedium: "Medium",
    difficultyHard: "Hard",
    allGuides: "All guides",
    by: "By",
    minRead: "min read",
    noResults: "No guides found. Try a different search or category.",
    relatedGuides: "Related guides",
    readGuide: "Read guide",
  },
  news: {
    pillLabel: "Heartopia News",
    titleWhats: "What's",
    titleAccent: "New",
    searchPlaceholder: "Search news…",
    categoryAll: "All",
    categoryEvent: "Event",
    categoryUpdate: "Update",
    categoryGuide: "Guide",
    categoryNews: "News",
    featured: "Featured",
    allNews: "All news",
    read: "Read",
  },
  map: {
    controls: "Map controls",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    resetMap: "Reset map",
    fullscreen: "Fullscreen",
    viewDetails: "View details",
    viewLocation: "View location",
    openFullMap: "Open full map",
    seeMore: "See more",
    close: "Close",
    back: "Back",
    guide: "Guide",
    searchPlaceholder: "Search NPCs, shops, birds, fish...",
    clearSearch: "Clear search",
    area: "Area",
    mapArea: "Map area",
    event: "Event",
    resource: "Resource",
    location: "Location",
    npc: "NPC",
    shop: "Shop",
    busStop: "Bus Stop",
    wildAnimal: "Wild Animal",
    focus: "Focus",
    hide: "Hide",
    show: "Show",
    showAllShops: "Show all shops",
    showAllAnimals: "Show all animals",
    showBugAreas: "Show bug areas",
    showBirdAreas: "Show bird areas",
    showResources: "Show resources on map",
    showEvents: "Show events on map",
    showFishAreas: "Show fish areas",
    viewAnimalAreas: "View animal areas",
    clickToView: "Click to view",
    spots: "spots",
    meteorShower: "Meteor shower",
    foundIn: "Found in",
    more: "more",
    sectionsNpcs: "NPCs",
    sectionsShops: "Shops",
    sectionsBusStops: "Bus Stops",
    sectionsAnimals: "Animals",
    sectionsBugs: "Bugs",
    sectionsBirds: "Birds",
    sectionsResources: "Resources",
    sectionsWeather: "Weather",
    sectionsEvents: "Events",
    sectionsFish: "Fish",
    shopClothes: "Clothes",
    shopFurniture: "Furniture",
    shopPets: "Pets",
    shopBookstore: "Bookstore",
    helpTitle: "How to use the map",
    helpSearchLead: "Search",
    helpSearchText: "for any NPC, shop, creature, or area by name using the bar at the top.",
    helpLayersLead: "Layers",
    helpLayersText:
      "in the sidebar toggle what's visible on the map: NPCs, Shops, Animals, Resources, and more. Tap a category to expand its full list.",
    helpClickLead: "Click a pin, area, or list item",
    helpClickText:
      "to see basic info in the card at the bottom of the map, with a button to see the full details page when one exists.",
  },
  locations: {
    title: "Locations",
    subtitleSuffix: "locations across Heartopia Island",
    openMap: "Open Map",
    searchPlaceholder: "Search locations…",
    allLocations: "All Locations",
    npcsHere: "NPCs Here",
    shopsHere: "Shops Here",
    listings: "listings",
    foundHereTitle: "Found Here",
    foundHereHint: "Creatures and resources you can collect at this spot.",
    onTheMapTitle: "On the Map",
    sameRegionTitle: "More in {region}",
    statNpcs: "NPCs",
    statShops: "Shops",
    statCollectibles: "Collectibles",
    levelShort: "Lv. {level}",
    eventOnly: "Event",
    seeListings: "See listings",
    seeAll: "See all",
    timeOfDay: "Time of day",
    nothingHereTitle: "Nothing recorded here yet",
    nothingHereBody:
      "We have no creatures, shops or NPCs on file for this spot. If you have found something here, the map is the fastest way to show us where.",
    regionTown: "Town",
    regionNature: "Nature",
    regionAdventure: "Adventure",
    regionCoast: "Coast",
    regionSea: "Sea",
    regionRegion: "Region",
    regionFishingVillage: "Fishing Village",
    regionForest: "Forest",
    regionMountain: "Mountain",
    regionBeach: "Beach",
    regionOther: "Other",
  },
  catalog: {
    howItWorks: "How it works",
    fishPill: "Fishing Encyclopedia",
    fishTitlePrefix: "Catch",
    fishTitleAccent: "Every Fish",
    fishSearchPlaceholder: "Search fish, habitat, shadow size…",
    fishSliderLabel: "Fishing Level",
    fishIntroTitle: "Fishing 101",
    fishIntroP1: "Cast your line near a fish's habitat to catch it — the shadow size hints at what's biting.",
    fishIntroP2: "Higher fishing level unlocks rarer catches, and star quality multiplies your sell price.",
    fishUnknownHabitat: "Unknown waters",
    fishHabitat: "Habitat",
    fishNoResultsTitle: "No fish found",
    fishNoResultsBody: "Try adjusting your filters.",
    fishPastEventTitle: "Past Event Fish",
    fishHeaderTitle: "Fish",
    fishColFish: "Fish",
    fishColShadow: "Shadow",
    insectsPill: "Bug Catching Encyclopedia",
    insectsTitlePrefix: "Catch",
    insectsTitleAccent: "Every Bug",
    insectsSearchPlaceholder: "Search insects, habitat…",
    insectsSliderLabel: "Catching Level",
    insectsIntroTitle: "Bug Catching 101",
    insectsIntroP1: "Use your insect net near an insect's habitat to catch it.",
    insectsIntroP2: "Higher catching level unlocks rarer bugs, and star quality multiplies your sell price.",
    insectsUnknownHabitat: "Unknown",
    insectsPastEventTitle: "Past Event Insects",
    insectsHeaderTitle: "Insects",
    insectsColInsect: "Insect",
    birdsPill: "Birdwatching Encyclopedia",
    birdsTitlePrefix: "Spot",
    birdsTitleAccent: "Every Bird",
    birdsSearchPlaceholder: "Search birds, habitat…",
    birdsSliderLabel: "Birdwatching Level",
    birdsIntroTitle: "Birdwatching 101",
    birdsIntroP1: "Wait near a bird's habitat with your camouflage bush to snap a photo.",
    birdsIntroP2: "Higher birdwatching level unlocks rarer species.",
    birdsUnknownHabitat: "Unknown",
    birdsPastEventTitle: "Past Event Birds",
    birdsHeaderTitle: "Birds",
    birdsColBird: "Bird",
    cropsPill: "Farming Encyclopedia",
    cropsTitlePrefix: "Grow",
    cropsTitleAccent: "Every Crop",
    cropsSearchPlaceholder: "Search crops…",
    cropsIntroTitle: "Farming 101",
    cropsIntroP1: "Plant seeds in your farm plot and water them daily until harvest.",
    cropsIntroP2: "Some crops only grow in certain seasons — check the season badge before planting.",
    cropsAllSeasons: "All Seasons",
    cropsGrowthTime: "Growth Time",
    cropsGrowthTimeUnknown: "Unknown",
    cropsGrowthTimeMinutesSuffix: "min",
    cropsSortGrowthTime: "Growth Time",
    cropsHeaderTitle: "Crops",
    cropsColCrop: "Crop",
    cropsColSeason: "Season",
    flowersPill: "Gardening Encyclopedia",
    flowersTitlePrefix: "Grow",
    flowersTitleAccent: "Every Flower",
    flowersSearchPlaceholder: "Search flowers…",
    flowersIntroTitle: "Gardening 101",
    flowersIntroP1: "Plant flower seeds and water them to bloom.",
    flowersHeaderTitle: "Flowers",
    flowersColFlower: "Flower",
    furniturePill: "Furniture Catalogue",
    furnitureTitlePrefix: "Every",
    furnitureTitleAccent: "Piece of Furniture",
    furnitureSearchPlaceholder: "Search furniture…",
    furnitureMetaDescription:
      "Every piece of furniture in Heartopia — lighting, chairs, tables, beds, rugs and decorations — filterable by type, room and colour, with all appearance variants and shop prices in gold and Wishing Stars.",
    browseAll: "All",
    browseVariants: "{count} designs",
    browseShowMore: "Show {count} more",
    browseFacetRooms: "Room",
    browseFacetColors: "Colour",
    browseFacetSlots: "Slot",
    browseFacetTypes: "Type",
    browseFacetSets: "Collections",
    browseCollectionsMore: "See all",
    browseCollectionsLess: "Show fewer",
    browseCollectionPieces: "{count} pieces",
    browseFavourites: "Favourites",
    browseNoArt: "The game ships no picture for this one",
    browseFacetStyles: "Build styles",
    buildingsPill: "Build Mode Catalogue",
    buildingsTitlePrefix: "Every",
    buildingsTitleAccent: "Building Piece",
    buildingsSearchPlaceholder: "Search doors, roofs, windows…",
    buildingsMetaDescription:
      "Every build-mode piece in Heartopia — doors, windows, roofs, fences, wall sculptures and wall or floor textures — grouped by build style, with prices and every design variant.",
    wardrobePill: "Wardrobe Catalogue",
    wardrobeTitlePrefix: "Every",
    wardrobeTitleAccent: "Outfit & Accessory",
    wardrobeSearchPlaceholder: "Search clothing…",
    wardrobeMetaDescription:
      "Every hat, top, bottom, pair of shoes, bag and accessory in Heartopia, filterable by slot and colour, with shop prices in gold and Wishing Stars.",
    forageablesPill: "Foraging Encyclopedia",
    forageablesTitlePrefix: "Find",
    forageablesTitleAccent: "Every Forageable",
    forageablesSearchPlaceholder: "Search forageables…",
    forageablesIntroTitle: "Foraging 101",
    forageablesIntroP1: "Walk around the island and pick up wild plants and mushrooms as you find them.",
    forageablesEnergy: "Energy",
    forageablesSortEnergy: "Energy",
    forageablesHeaderTitle: "Forageables",
    forageablesColItem: "Item",
    recipesPill: "Recipe Masterlist",
    recipesTitlePrefix: "Cook",
    recipesTitleAccent: "Every Dish",
    recipesSearchPlaceholder: "Search recipes…",
    recipesIntroTitle: "Cooking 101",
    recipesIntroP1: "Gather ingredients and use a stove, oven, or grill to cook.",
    recipesIntroP2: "Higher cooking level unlocks fancier recipes with bigger profit margins.",
    recipesSortCookingLevel: "Cooking Level",
    recipesSortProfit: "Profit",
    recipesEstProfit: "Est. Profit",
    recipesViewRecipe: "View recipe",
    recipesHeaderTitle: "Recipes",
    recipesColDish: "Dish",
    recipesBeginnerFriendly: "Beginner Friendly",
    recipesBestStartersTitle: "Best Recipes to Start With",
    recipesBestStartersSubtitle: "Low cooking level, solid profit — good picks for your first Cooking Hobby unlocks.",
    npcsPill: "Townsfolk Directory",
    npcsTitlePrefix: "Meet",
    npcsTitleAccent: "Every NPC",
    npcsSearchPlaceholder: "Search NPCs…",
    npcsFilterAll: "All",
    npcsFilterMentors: "Mentors",
    npcsFilterShopkeepers: "Shopkeepers",
    npcsFilterSpecial: "Special",
    npcsNoResultsTitle: "No NPCs Found",
    npcsNoResultsBody: "Try adjusting your search",
    npcsResetFilters: "Reset Filters",
    locationsPill: "Island Atlas",
    locationsTitlePrefix: "Explore",
    locationsTitleAccent: "Every Location",
    locationsFilterAll: "All",
    locationsNoResultsTitle: "No Locations Found",
    locationsNoResultsBody: "Try adjusting your search",
    locationsResetFilters: "Reset Filters",
    shopsPill: "Shop Directory",
    shopsTitlePrefix: "Every",
    shopsTitleAccent: "Shop In Town",
    shopsRunBy: "Run by:",
    shopsAt: "At",
    shopsItemsForSale: "items for sale",
    shopsSearchPlaceholder: "Search shops, NPCs, locations…",
    shopsNoResultsTitle: "No Shops Found",
    shopsNoResultsBody: "Try adjusting your search",
    shopsResetFilters: "Reset Filters",
    animalsBadge: "Wild Animal Guide",
    animalsTitlePrefix: "Meet",
    animalsTitleAccent: "Every Animal",
    animalsPastEvent: "Past event",
    animalsPastEventTitle: "Past Event Animals",
    trackerBadge: "Collection progress",
    trackerTitle: "Heartopia Tracker",
    trackerDescription:
      "Mark fish, insects, birds, crops, flowers, forageables, recipes, and wild animals as collected. Progress is saved in this browser.",
    trackerMetaDescription:
      "Track your Heartopia collection progress across fish, insects, birds, crops, flowers, forageables, animals, and recipes.",
    trackerCategoryTitle: "{category} Tracker",
    trackerCategoryMetaDescription:
      "Track your Heartopia {category} collection progress — see what you've caught, grown, or cooked, and what's still missing.",
    trackerTotal: "Total",
    trackerExport: "Export",
    trackerImport: "Import",
    trackerReset: "Reset",
    trackerImportComplete: "Import complete.",
    trackerImportFailed: "Import failed.",
    trackerSearchPlaceholder: "Search collection...",
    trackerAllCategories: "All categories",
    trackerAllItems: "All items",
    trackerCollected: "Collected",
    trackerMissing: "Missing",
    trackerNoResults: "No tracker items match the current filters.",
  },
  genericDetail: {
    subtitle: "Item encyclopedia entry",
    sellPrice: "Sell Price",
    energy: "Energy",
    whereToBuy: "Where to Buy",
    tags: "Tags",
    crafted: "Crafted",
    aliases: "Also known as",
    howToObtain: "How to obtain",
    growsInto: "Grows Into",
    universalIngredientTitle: "Flexible cooking ingredient",
    universalIngredientBody: "Can be used in place of any ingredient when cooking a recipe.",
  },
  animalDetail: {
    backLabel: "All Animals",
    subtitle: "Wild Animal Guide entry",
    statLocation: "Location",
    statFavoriteWeather: "Favorite Weather",
    foundInTitle: "Found In",
    favoriteFoodsTitle: "Favorite Foods",
    noPinTitle: "This animal's exact spot isn't pinned yet.",
    noPinDescription: "It wanders within its area, so we haven't mapped a fixed marker for it.",
    weatherSunny: "Sunny",
    weatherWet: "Rainy",
    weatherRainbow: "Rainbow",
    weatherSnowy: "Snowy",
    faqTitle: "Frequently Asked Questions",
  },
  cropDetail: {
    backLabel: "All Crops",
    subtitle: "Farming Encyclopedia entry",
    statGrowthTime: "Growth Time",
    statSellPrice: "Sell Price",
    aboutTitle: "About",
    seedCostTitle: "Seed Cost",
    usedInRecipesTitle: "Used in Recipes",
    sellPriceByStarTitle: "Sell Price by Star",
    faqTitle: "Frequently Asked Questions",
    shopsTitle: "Where to Buy Seeds",
  },
  creatureDetail: {
    allBirds: "All Birds",
    allInsects: "All Insects",
    allFish: "All Fish",
    birdSubtitle: "Birdwatching Encyclopedia entry",
    insectSubtitle: "Bug Catching Encyclopedia entry",
    fishSubtitle: "Fishing Encyclopedia entry",
    statShadowSize: "Shadow Size",
    markAsObtained: "Mark as obtained",
    shopsTitle: "Where to Buy",
    locationsTitle: "Habitat",
    sellPriceByStarTitle: "Sell Price by Star",
    starChanceHint: "Chance of getting this star tier",
    statWeightRange: "Weight",
    faqTitle: "Frequently Asked Questions",
  },
  forageableDetail: {
    backLabel: "All Forageables",
    subtitle: "Foraging Encyclopedia entry",
    statEnergy: "Energy",
    shopsTitle: "Where to Buy",
    locationsTitle: "Found In",
    aboutBody: "Walk around the island and pick this up as you find it in the wild.",
    faqTitle: "Frequently Asked Questions",
  },
  flowerDetail: {
    backLabel: "All Flowers",
    shopsTitle: "Where to Buy Seeds",
    encyclopediaEntry: "Gardening Encyclopedia entry",
    colorsTitle: "Colors",
    otherColorsTitle: "Other Colors",
    crossbreedingTitle: "Crossbreeding",
    crossbreedingFact1:
      "Only works within the same species — a rose only crossbreeds with another rose, never a tulip.",
    crossbreedingFact2:
      "Flowers have a star level (1-5). Two matching-star parents can produce that same star or the next one up; adjacent stars (like 2★ and 3★) work the same way. Nothing crossbreeds across a bigger gap, and 5★ flowers are done — no more seeds.",
    crossbreedingFact3:
      "Color doesn't work as an ingredient — parents' colors never combine into a third color. Each color tends to belong to one particular star tier for its species, so which colors you can get depends more on the star level you land on than on which colors you started with.",
    crossbreedingFact4:
      "Watering raises the odds, capped around 5 people total (you plus up to 4 helpers), and your Gardening level adds its own bonus. Results land after the server's 6:00 reset.",
    crossbreedingDisclaimer:
      "Exact success percentages aren't publicly documented anywhere reliable yet — advancing a tier is possible, never guaranteed.",
    faqTitle: "Frequently Asked Questions",
  },
  npcDetail: {
    backLabel: "All NPCs",
    aboutTitle: "About",
    funFactsTitle: "Fun Facts",
    foundInTitle: "Found In",
    itemsForSale: "items for sale",
    profileTitle: "Profile",
    birthdayLabel: "Birthday",
    zodiacLabel: "Zodiac",
    mbtiLabel: "MBTI",
    likesTitle: "Likes",
    roleLabel: "Role",
    teachesLabel: "Teaches",
    forSaleLabel: "For Sale",
    townsfolkFallback: "Townsfolk",
    townsfolkSubtitle: "Townsfolk of Heartopia",
    itemsSuffix: "items",
    noMapPinTitle: "This NPC's exact spot isn't pinned yet.",
    noMapPinDescription: "They roam or move around, so we haven't mapped a fixed marker for them.",
    currencyGold: "gold",
    currencyStars: "stars",
    currencyWishingStars: "wishing stars",
    currencyMoonlightCrystals: "moonlight crystals",
    currencyHeartDiamonds: "heart diamonds",
    currencyExhibitionPasses: "exhibition passes",
    currencyContributionMedals: "contribution medals",
    seeAllShopItems: "See all {count} items in {shop} →",
  },
  recipeDetail: {
    faqIngredientsQuestion: "How do I make {name}?",
    faqIngredientsAnswer: "{name} needs: {ingredients}.",
    faqLevelQuestion: "What cooking level do I need for {name}?",
    faqLevelAnswer: "You need cooking level {level} to unlock {name}.",
    faqSellQuestion: "How much does {name} sell for?",
    faqSellAnswer: "{name} sells for {price} gold.",
    faqStarQuestion: "How much is a 5-star {name} worth?",
    faqStarAnswer: "{name} sells for {min} gold at 1★ and {max} gold at 5★ — {times}× more for a perfect cook.",
    faqEnergyQuestion: "How much energy does {name} restore?",
    faqEnergyAnswer: "{name} restores {min} energy at 1★ and {max} energy at 5★.",
    backLabel: "All Recipes",
    subtitle: "Recipe Masterlist entry",
    statCookingLevel: "Cooking Level",
    statTool: "Tool",
    statSellPrice: "Sell Price",
    shopsTitle: "Where to Buy",
    aboutTitle: "About",
    faqTitle: "Frequently Asked Questions",
    ingredientsTitle: "Ingredients",
    noIngredients: "No ingredients recorded for this recipe.",
    missingIngredientsTitle: "We don't know the ingredients for this recipe",
    missingIngredientsCta: "Tap to add them",
    suggestIngredientsModalTitle: "Suggest ingredients",
    ingredientSearchPlaceholder: "Search for an item…",
    ingredientQtyLabel: "Qty",
    addIngredientRow: "Add ingredient",
    removeIngredientRow: "Remove",
    submitIngredients: "Send suggestion",
    submittingIngredients: "Sending…",
    ingredientsSuccessMessage: "Thanks! We'll review your suggestion soon.",
    ingredientsErrorMessage: "Couldn't send right now — please try again later.",
    itemNotFoundCta: "Can't find it? Suggest a new item",
    newItemPendingBadge: "pending",
    suggestNewItemModalTitle: "Suggest a new item",
    newItemNameLabel: "Item name",
    newItemNamePlaceholder: "e.g. Mandarin",
    newItemKindLabel: "Category",
    newItemNotesLabel: "Notes (optional)",
    newItemNotesPlaceholder: "Anything that helps us add it — where it's found, what it looks like…",
    submitNewItem: "Send suggestion",
    submittingNewItem: "Sending…",
    newItemSuccessMessage: "Thanks! We'll review and add it soon.",
    newItemErrorMessage: "Couldn't send right now — please try again later.",
    anyTag: "any",
    possibleSubstitutesTitle: "Possible substitutes",
    possibleSubstitutesNote: "Every catalog item of this type — Heartopia's actual accepted list may be narrower.",
    estIngredientCost: "Est. Ingredient Cost",
    estProfit: "Est. Profit",
    sellPriceByStar: "Sell Price by Star",
    starScalingNote:
      "Standard cooking scaling (1x/1.5x/2x/4x/8x) — a small number of dishes are known to use a different table.",
    energyByStar: "Energy by Star",
    toolStove: "Stove",
    toolOven: "Oven",
    toolPopcornServingCart: "Popcorn Cart",
    toolPenguinStove: "Penguin Stove",
    toolBrickServingCart: "Brick Serving Cart",
    toolNone: "None",
  },
  common: {
    loading: "Loading",
    overviewTitle: "Overview",
    viewDetails: "View details",
    cards: "Cards",
    list: "List",
    sort: "Sort",
    name: "Name",
    level: "Level",
    price: "Sell Price",
    clearFilters: "Clear filters",
    day: "day",
    days: "days",
    shadowSizeSmall: "Small",
    shadowSizeMedium: "Medium",
    shadowSizeLarge: "Large",
    shadowSizeGolden: "Golden",
    usedInRecipesTitle: "Used in Recipes",
    aboutTitle: "About",
  },
  itemFaq: {
    whereToFindQuestion: "Where can I find {name} in Heartopia?",
    whereToFindByLocationsAnswer: "{name} can be found at {locations}.",
    whereToFindByHabitatAnswer: "{name} is associated with the {habitat} habitat.",
    levelRequiredQuestion: "What level do I need to catch {name}?",
    levelRequiredAnswer: "You need at least level {level} to catch {name}.",
    sellPriceQuestion: "How much does {name} sell for?",
    sellPriceAnswer: "{name} sells for {price} gold.",
    sellPriceWithShadowAnswer: "{name} sells for {price} gold, and its shadow size while fishing is {shadowSize}.",
    weatherQuestion: "What weather do I need for {name}?",
    weatherAnswer: "{name} appears during: {weather}.",
    usedForQuestion: "What is {name} used for?",
    usedForAnswer: "{name} restores {energy} energy when eaten.",
  },
  // Dishes get their own block rather than reusing itemFaq: the questions are about cooking, not
  // catching, and RecipeDetailPage had them hardcoded in English for every locale — including
  // pt-BR and es, live since the FAQ shipped. buildItemFaq was localized on 2026-08-09 and the
  // recipe page was missed because it builds its FAQ inline instead of calling that helper.
  recipeFaq: {
    ingredientsQuestion: "What ingredients do I need for {name}?",
    ingredientsAnswer: "{name} needs: {ingredients}.",
    cookingLevelQuestion: "What cooking level do I need for {name}?",
    cookingLevelAnswer: "You need cooking level {level} to unlock {name}.",
    sellPriceQuestion: "How much does {name} sell for?",
    sellPriceAnswer: "{name} sells for {price} gold.",
  },
  itemDescription: {
    foundAtClause: "is found at {locations}",
    foundInHabitatClause: "is found in the {habitat} habitat",
    requiresLevelClause: "requires at least level {level} to obtain",
    sellsForClause: "sells for {price} gold",
    restoresEnergyClause: "restores {energy} energy when eaten",
    joinWord: "and",
  },
  starTooltip: {
    profitTitle: "Star Multipliers",
    profitSubtitle: "Profit per star rating",
    profitFooterLabel: "1★ Profit",
    sellPriceTitle: "Star Multipliers",
    sellPriceSubtitle: "Sell price per star rating",
    sellPriceFooterLabel: "1★ Sell Price",
  },
  mastery: {
    trackFishing: "Fishing Mastery",
    trackBugCatching: "Bug Catching Mastery",
    trackBirdwatching: "Birdwatching Mastery",
    trackFarming: "Farming Mastery",
    trackCooking: "Cooking Mastery",
    unitCatches: "catches",
    unitCaptures: "captures",
    unitHarvests: "harvests",
    unitPreparations: "preparations",
    rankNovice: "Novice",
    rankExpert: "Expert",
    rankMaster: "Master",
    trophyUnlocked: "Trophy",
    footerHint: "Tap a rank to mark your progress. Reach Master to unlock the trophy.",
    unknownBody: "We don't know this item's mastery thresholds yet.",
    unknownCta: "Do you know them? Tell us",
    suggestFieldLabel: "Novice mastery threshold",
    suggestHint: "Just the Novice number — Expert is 3x it and Master 6x, on every item we've confirmed.",
  },
  statSuggestion: {
    unknownLabel: "We don't know yet",
    suggestValueCta: "Suggest a value",
    explainer:
      "We don't have this confirmed yet. If you know it from playing, share it below — every suggestion is reviewed before it goes on the site, so no pressure to be 100% sure.",
    genericHint: "Just the number, no need for extra formatting.",
    energyHint: "The amount of energy restored when this item is consumed.",
    sellPriceHint: "The base 1-star sell price, in Gold — we'll work out the other stars from it.",
    habitatHint: "Where it's found — the location or area name.",
    growthTimeHint: "In minutes (e.g. 90 for 1h30m, 1440 for 1 day).",
    valueLabel: "Value",
    customOption: "Other (type your own)",
    habitatTranslationFieldLabel: "Habitat name in this language",
    habitatTranslationHint: "How this location/area is called in this language.",
    submitButton: "Send suggestion",
    submitting: "Sending…",
    successMessage: "Thanks! We'll review your suggestion soon.",
    errorMessage: "Couldn't send right now — please try again later.",
  },
  imageSuggestion: {
    triggerLabel: "Suggest an image",
    triggerLabelReplace: "Suggest a different image",
    fieldLabel: "Suggest an image",
    explainer:
      "We don't have a confirmed image for this yet. Upload one you have — every suggestion is reviewed before it's added to the site.",
    explainerReplace:
      "Think this image is wrong or could be better? Upload one you have — every suggestion is reviewed before it replaces the current image.",
    pickFile: "Choose a photo (JPEG, PNG, or WebP)",
    hint: "Max 5MB. Please make sure the image is actually this item.",
    invalidType: "Only JPEG, PNG, or WebP images are accepted.",
    tooLarge: "Image must be 5MB or smaller.",
    submitButton: "Send image",
    submitting: "Uploading…",
    successMessage: "Thanks! We'll review your image soon.",
    errorMessage: "Couldn't upload right now — please try again later.",
  },
  generalFeedback: {
    triggerLabel: "Something wrong? Suggest a fix",
    fieldLabel: "What's off?",
    hint: "Wrong description, wrong image, anything else — tell us what to fix.",
  },
  pageFeedback: {
    triggerLabel: "Report an issue with this page",
    fieldLabel: "What's wrong?",
    hint: "Typo, broken step, outdated info — let us know.",
    explainer:
      "We don't have this confirmed yet. If you spotted something off, share it below — every submission is reviewed before we act on it, so no pressure to be 100% sure.",
    submitButton: "Send feedback",
    submitting: "Sending…",
    successMessage: "Thanks! We'll take a look soon.",
    errorMessage: "Couldn't send right now — please try again later.",
  },
  mapAreaUnknown: {
    title: "We don't know this area yet.",
    description: "Help the community by contributing location data for this item.",
    cta: "Help us add this",
    fieldLabel: "Location / area",
    hint: "Describe where you found it — the location name and any landmark nearby.",
    notPinnedTitle: "This spot isn't pinned on the map yet.",
    notPinnedDescription: "We know the general area, but haven't mapped an exact marker for it.",
  },
  itemGuides: {
    title: "Related Guides",
  },
  itemFallback: {
    badge: "Translation pending",
    message: "We don't know this item's name in this language yet.",
    usingEnglish: "Using English:",
    helpMessage: "We don't know this item's name yet. Want to help us?",
    helpCta: "Help translate",
    modalTitle: "Suggest a translation",
    fieldPlaceholder: "Item name in this language",
    submitButton: "Send suggestion",
    submitting: "Sending…",
    successMessage: "Thanks! We'll review your suggestion soon.",
    errorMessage: "Couldn't send right now — please try again later.",
  },
  notFoundPage: {
    title: "404",
    subtitle: "Oops, this page can't be found.",
    description: "You wandered into an area that doesn't exist in Heartopia yet. Let's get you back on track.",
    primaryCta: "Return Home",
    secondaryCta: "View World Map",
  },
  achievements: {
    pill: "Achievements",
    titlePrefix: "Unlock every",
    titleAccent: "achievement",
    subtitle: "Track your progress and discover how to unlock every achievement in Heartopia.",
    searchPlaceholder: "Search achievements…",
    filterAll: "All",
    showHidden: "Show Hidden",
    hideHidden: "Hide Hidden",
    statTotal: "Total",
    statCompleted: "Completed",
    statHidden: "Hidden",
    noResultsTitle: "No achievements found",
    noResultsBody: "Try a different search or filter.",
    resetFilters: "Reset filters",
    lockedTitle: "???",
    lockedBody: "This achievement is still a mystery.",
    titleGainedLabel: "Title Gained",
    hintLabel: "Hint",
    notesLabel: "Notes",
    markDone: "Mark as done",
    markNotDone: "Mark as not done",
    backToList: "Back to Achievements",
    relatedTitle: "Related Achievements",
    faqTitle: "Frequently Asked Questions",
  },
  share: {
    title: "Share",
    shareVia: "Share via…",
    copyLink: "Copy link",
    linkCopied: "Copied!",
  },
  weather: {
    pill: "Weather Station",
    titlePrefix: "Heartopia",
    titleAccent: "Forecast",
    subtitle: "Check conditions to plan your route, spot events, and prepare for rare spawns.",
    directoryTitle: "Weather & Event Guides",
    specialEvent: "Special Event",
    openGuide: "Open Guide",
    backToWeather: "Back to Weather",
    overviewTitle: "Overview",
    checklistTitle: "If You Only Have 10 Minutes",
    activitiesTitle: "Key Activities",
    bestForTitle: "Best For",
    creaturesTitle: "Available During This Weather",
    creaturesMore: "more",
    creaturesShowLess: "Show fewer",
    noCreaturesData: "We don't have creatures tagged for this weather yet.",
    faqTitle: "Frequently Asked Questions",
  },
  events: {
    pill: "Heartopia Schedule",
    titlePrefix: "Active",
    titleAccent: "Events",
    subtitle: "From major seasonal festivals to quick daily minigames, find everything happening in Heartopia.",
    minigamesTitle: "Recurrent Minigames",
    seasonalTitle: "Seasonal & Collab Events",
    activeLabel: "Active",
    endedLabel: "Ended",
    viewEvent: "View Event",
    backToEvents: "Back to Events",
    requirementsTitle: "Requirements",
    locationTitle: "Location",
    costTitle: "Entry Cost",
    freeLabel: "Free",
    dgLevelLabel: "Developer's Guild Level",
    questLabel: "Quest",
    hobbyLabel: "Hobby",
    quickFactsTitle: "Quick Facts",
    unlockLabel: "Unlock",
    npcAreaLabel: "NPC / Area",
    durationLabel: "Duration",
    typeLabel: "Type",
    howToStartTitle: "How to Start",
    howItWorksTitle: "How It Works",
    goalsRewardsTitle: "Goals & Rewards",
    tipsTitle: "Tips / Strategy",
    datesTitle: "Event Dates",
    overviewTitle: "Overview",
    highlightsTitle: "Highlights",
    standoutRewardTitle: "Standout Reward",
    faqTitle: "Frequently Asked Questions",
  },
  pets: {
    hubBadge: "Pets Guide",
    hubTitlePrefix: "Heartopia",
    hubTitleAccent: "Pets",
    hubSubtitle: "Everything you need to unlock, adopt, and care for pets.",
    hubUnlockTitle: "Unlock Pet Caring",
    hubUnlockDesc: "Usually at Developer/Member Level 12 via Resident Requests.",
    hubOrderTitle: "Cat First",
    hubOrderDesc: "You must adopt a cat before dogs unlock.",
    hubRotationTitle: "Daily Rotation",
    hubRotationDesc: "3 cats + 3 dogs rotate every day at the Adoption Center.",
    cardDogsTitle: "Dogs",
    cardDogsSubtitle: "Breeds • Caring • Groups",
    cardDogsDesc: "37 breeds with size groups and caring notes.",
    cardCatsTitle: "Cats",
    cardCatsSubtitle: "Breeds • Traits • Coats",
    cardCatsDesc: "18 breeds with coat variants and colors.",
    cardTraitsTitle: "Traits",
    cardTraitsSubtitle: "All traits + search",
    cardTraitsDesc: "Searchable list of traits and their effects.",
    cardGuideTitle: "Guide",
    cardGuideSubtitle: "Unlock • Adopt • Care",
    cardGuideDesc: "Unlock flow plus the daily adoption/care loop.",
    dogsBadge: "Dog Guide",
    dogsTitlePrefix: "Heartopia",
    dogsTitleAccent: "Dogs",
    dogsSubtitle: "Unlock, adopt, and care for dogs with a clean breed catalog.",
    catsBadge: "Cat Guide",
    catsTitlePrefix: "Heartopia",
    catsTitleAccent: "Cats",
    catsSubtitle: "Breeds, traits, and care — clean and separated.",
    quickInfoRotationTitle: "Daily Rotation",
    quickInfoRotationDesc: "3 cats + 3 dogs rotate every day.",
    quickInfoUnlockTitle: "Unlock",
    quickInfoUnlockDesc: "Dog Caring opens after Cat Caring.",
    quickInfoOrderTitle: "Cat First",
    quickInfoOrderDesc: "Cats unlock before dogs.",
    quickInfoTraitsTitle: "Random Traits",
    quickInfoTraitsDescDogs: "Traits are random, not tied to breed.",
    quickInfoTraitsDescCats: "Traits are random and behavior-focused.",
    searchPlaceholder: "Search breeds…",
    filterAll: "All",
    filterSmall: "Small",
    filterMedium: "Medium",
    filterLarge: "Large",
    noResults: "No breeds found",
    traitsBadge: "Pet Traits",
    traitsTitlePrefix: "All",
    traitsTitleAccent: "Traits",
    traitsSubtitle: "Every trait a pet can have and what it means for daily care.",
    traitsSearchPlaceholder: "Search traits…",
    effectLabel: "Effect",
    guideBadge: "Pet Caring",
    guideTitlePrefix: "Adoption",
    guideTitleAccent: "Guide",
    guideSubtitle: "Unlock pet caring, adopt your first cat, then expand to dogs.",
    guideStepsTitle: "How to Unlock",
    guideAdoptionTitle: "How Adoption Works",
    guideCareTitle: "Daily Care Loop",
    backToPets: "Back to Pets",
    viewBreed: "View Breed",
    groupLabel: "Size",
    dogLabel: "Dog",
    catLabel: "Cat",
    variantsLabel: "Known Coat Variants",
    suggestTitle: "Missing a breed or detail?",
    suggestDogsBody: "Help us expand the dog catalog with a breed, variant, or correction.",
    suggestCatsBody: "Help us expand the cat catalog with a breed, coat variant, or correction.",
    suggestButton: "Suggest an entry",
    suggestFieldLabel: "Pet information",
    suggestHint: "Share the breed, variant, source, or correction you know.",
    viewAllTraits: "View all traits",
  },
  dailyChecklist: {
    badge: "Daily Tracker",
    titlePrefix: "Daily",
    titleAccent: "Heartopia",
    subtitle: "Track your daily tasks, resources, and shop rotations. Everything resets with a new day.",
    progressTitle: "Daily Progress",
    progressComplete: "complete",
    allDone: "Congratulations! You've completed all of today's tasks!",
    quickTasksTitle: "Quick Tasks",
    quickTasksDesc: "Essential daily actions that reset each day.",
    shopsTitle: "Shop Rotations",
    shopsDesc: "Check rotating stock from these vendors.",
    resetInfo: "Resets automatically based on your local date.",
    customTitle: "Custom Tasks",
    addCustom: "Add",
    customPlaceholder: "Task name…",
    customEmpty: "No custom tasks yet.",
    remove: "Remove",
  },
  codes: {
    badge: "Redemption Center",
    title: "GIFT",
    titleAccent: "CODES",
    subtitle: "Redeem these codes in-game to receive special rewards, gold, and exclusive items!",
    statActive: "Active",
    statExpired: "Expired",
    statTotal: "Total",
    howToTitle: "How to Redeem",
    howToStep1: "Open the game menu",
    howToStep2: "Tap on 'Settings' > 'Redeem Code'",
    howToStep3: "Enter the code exactly as shown",
    howToStep4: "Confirm and receive your rewards!",
    rewardsLabel: "Rewards",
    noRewardsLabel: "No rewards listed",
    starQualityHint: "This code grants the item at a specific star quality.",
    unconfirmedRewardHint:
      "We don't have this item in our catalog yet, so this is the raw in-game id rather than a confirmed name.",
    expiredText: "This code has expired and can no longer be redeemed.",
    copyCode: "Copy code",
    copied: "Copied!",
    statusActive: "ACTIVE",
    statusExpired: "EXPIRED",
    redeemedLabel: "Redeemed",
    markRedeemed: "Mark as redeemed",
    unmarkRedeemed: "Unmark redeemed",
    goldLabel: "Gold",
    starLabel: "Wishing Star",
    heartLabel: "Moonlight Crystal",
    maintenanceNote:
      "Codes are checked periodically but may expire without notice — if one doesn't work in-game, it's likely outdated.",
  },
  winterTracker: {
    badge: "Fashionwave Journal",
    titlePrefix: "Winter Frost",
    titleAccent: "Items Tracker",
    subtitle:
      "Track every limited-edition item from the Winter Frost season — this event has ended, but you can still browse what was available.",
    endedNote:
      "This event has ended — items shown here are no longer obtainable in-game. Kept as a reference for what was available.",
    searchPlaceholder: "Search items…",
    filterAll: "All",
    filterAccessory: "Accessories",
    filterBag: "Bags",
    filterClothing: "Clothing",
    filterFurniture: "Furniture",
    filterEmote: "Emotes",
    filterVehicle: "Vehicles",
    filterTool: "Tools",
    filterPet: "Pet Items",
    filterPuzzle: "Puzzles",
    collected: "Collected",
    missing: "Missing",
    noResults: "No items found",
    costLabel: "Fashionwave Tokens",
    backToEvent: "Back to Winter Frost",
  },
  support: {
    badge: "Support heartopia.guide",
    titlePrefix: "Keep the",
    titleAccent: "Heart",
    titleSuffix: "Beating",
    subtitle:
      "heartopia.guide is a passion project made for the community. Your support helps keep the servers running and the updates coming!",
    donateCta: "Support the Project",
    donateDescription: "Every contribution helps cover hosting, domain, and development time.",
    creatorLabel: "Lucas Diniz",
    creatorRole: "Creator of heartopia.guide",
    creatorBadge: "Developer & Designer",
    footerNote: "Thank you for being part of this journey!",
  },
  about: {
    badge: "Fan Project · Unofficial",
    title: "About Heartopia Guide",
    subtitle:
      "Heartopia Guide is a community-made website created to help players find useful game information — guides, trackers, checklists, items, and event references — in a fast, organized way.",
    lastUpdatedLabel: "Last updated",
    pillEventTrackers: "Event Trackers",
    pillGuides: "Guides",
    pillChecklists: "Checklists",
    pillAlwaysUpdated: "Always Updated",
    whatYouFindTitle: "What you'll find here",
    whatYouFind1: "Event trackers and item lists (when available)",
    whatYouFind2: "Guides and reference pages for game mechanics",
    whatYouFind3: "Utility pages to make daily/weekly routines easier",
    whatYouFind4: "A site that evolves over time — updated as new information becomes available",
    transparencyTitle: "Transparency and fan project notice",
    transparencyP1:
      "This is an independent, unofficial fan project. We are not affiliated with, sponsored by, or endorsed by the creators or publishers of Heartopia.",
    transparencyP2: "All trademarks, names, and assets belong to their respective owners.",
    creatorTitle: "Who's behind this",
    creatorIntro: "heartopia.guide isn't an anonymous project — it's built and maintained by a real person.",
    creatorName: "Lucas Diniz",
    creatorRole: "Creator & developer of heartopia.guide",
    creatorLinkLabel: "lucashdo.com",
    sourcesTitle: "Where information comes from",
    sourcesIntro: "Information may be sourced from:",
    sourcesItem1: "In-game observation and testing",
    sourcesItem2: "Community contributions",
    sourcesItem3: "Official game updates",
    sourcesNote: "Even with care, some data may be incomplete or out of date — especially during active events.",
    adsTitle: "Ads and sustainability",
    adsP1: "To keep the site running and cover costs (domain, hosting, tooling), we may display advertising.",
    adsP2: "Advertising services such as Google may use cookies or similar technologies to serve and measure ads.",
    copyrightTitle: "Copyright",
    copyrightText:
      "If you're a rights holder and believe content should be removed or adjusted, contact us with the relevant URL(s) and details. We'll review and act as quickly as possible.",
    contactTitle: "Contact",
    contactEmailLabel: "Email",
    footerNote: "Made with love by the Heartopia community",
  },
  legal: {
    lastUpdatedLabel: "Last updated",
    lastUpdatedValue: "2026-02-13",
    contactHeading: "Contact",
    contactLinkLabel: "About & Contact page",
    privacyTitle: "Privacy Policy",
    privacyIntro:
      "This Privacy Policy explains how heartopia.guide collects, uses, and protects personal information when you access this site.",
    privacyDataHeading: "Data we may collect",
    privacyData:
      "Depending on how you use the site, we may collect: browsing/usage data (pages viewed, clicks, date/time, referrer, device/browser type, language); technical identifiers (e.g. IP in logs, security and performance data); cookies and similar tech (see Cookie Policy); and data you provide (e.g. if you email us or submit feedback). We do not request sensitive data (e.g. health, religion, biometrics).",
    privacyHowWeUseHeading: "How we use data",
    privacyHowWeUse:
      "We use data to provide and maintain the website, improve content and performance, prevent abuse and fraud, respond to messages and support, measure audience when enabled, and serve ads (if applicable) and measure performance.",
    privacySharingHeading: "Sharing",
    privacySharing:
      "We may share data with service providers (hosting, analytics, CDN, and/or advertising) to operate the site; when legally required (court orders, regulatory obligations); and to protect the site and users. We do not sell personal information.",
    privacyRetentionHeading: "Retention",
    privacyRetention:
      "We keep data only as long as needed for the purposes described (or as required by law). Technical logs may be retained for limited periods for security and diagnostics.",
    privacyRightsHeading: "Your rights",
    privacyRights:
      "You may request applicable rights under relevant laws (e.g. access, correction, deletion, portability when applicable, information about sharing, withdrawal of consent). To exercise rights, contact us via the contact page with your request details.",
    privacyAdvertisingHeading: "Advertising",
    privacyAdvertising:
      "We use third-party advertising services, including Google AdSense. These providers may use cookies and similar identifiers to serve advertisements, including personalized ads based on your previous visits to this site and other websites.\n\nYou can opt out of personalized advertising through Google Ads Settings and/or AboutAds (interest-based advertising opt-out). Non-personalized ads may still be shown based on general content and location.",
    privacyContactBefore: "For questions or to exercise your rights, use our ",
    termsTitle: "Terms of Use",
    termsIntro:
      'By accessing this site (the "Site"), you agree to these Terms. The Site provides informational content and community tools. You agree to use it lawfully and respectfully.',
    termsUseHeading: "Intellectual property and trademarks",
    termsUse:
      "Original Site content (text, structure, design) belongs to heartopia.guide unless stated otherwise. Heartopia, character/item names, trademarks, and referenced assets belong to their respective owners. Third-party content may appear for reference; if you are a rights holder and want removal or adjustment, contact us.",
    termsLiabilityHeading: "Disclaimer and limitation of liability",
    termsLiability:
      'The Site is provided "as is." Content may be incomplete, outdated, or temporarily unavailable. We do not guarantee continuous availability or full accuracy. To the extent permitted by law, we are not liable for indirect damages, data loss, loss of profits, or other losses arising from use of the Site. We may update the Site and these Terms at any time; continued use after changes means acceptance.',
    termsContactBefore: "For questions or requests, use our ",
    cookiesTitle: "Cookie Policy",
    cookiesIntro:
      "This Cookie Policy explains how heartopia.guide uses cookies and similar technologies to recognize visitors and improve the experience.",
    cookiesWhatAreHeading: "What cookies are",
    cookiesWhatAre:
      "Cookies are small text files stored in your browser when you visit a website. They help with functionality, preferences, and usage statistics.",
    cookiesHowWeUseHeading: "How we use cookies",
    cookiesHowWeUse:
      "We may use cookies for: Essential (required) — needed for core site functionality (security, performance, critical preferences). Preferences — e.g. language, theme, filters. Analytics — to understand how the site is used and improve content. Advertising (if applicable) — partners may use cookies to measure performance and personalize ads.",
    cookiesThirdPartyHeading: "Third-party cookies",
    cookiesThirdParty:
      "We may use third-party services (e.g. hosting, analytics, CDNs, ad networks). These providers may set their own cookies. You can review or manage them via the site's consent banner.",
    cookiesConsentHeading: "Consent and control",
    cookiesConsent:
      "You can control cookies via the consent banner shown on your first visit, browser settings (block or delete cookies), or private/incognito mode. Blocking essential cookies may break site features.",
    cookiesContactBefore: "For questions about cookies, use our ",
    sitemapTitle: "Sitemap",
    sitemapIntro: "Main sections and pages of heartopia.guide.",
    sitemapXmlLabel: "sitemap.xml",
    sitemapXmlNote: "for search engines",
    sitemapResourcesHeading: "Resources",
    sitemapSupportHeading: "Support",
    sitemapLegalHeading: "Legal",
  },
  consent: {
    bannerLabel: "Cookie consent",
    message: "We use cookies for essential site features and, if you allow it, to measure usage and show ads.",
    learnMore: "Learn more about cookies",
    acceptCta: "Accept all",
    rejectCta: "Reject non-essential",
  },
} as const;

export default en;

type Widen<T> = { [K in keyof T]: T[K] extends string ? string : Widen<T[K]> };
export type Dictionary = Widen<typeof en>;
